import React from 'react';
import { Grid, GridItem, Stack, Divider, HStack, Button, Text } from '@chakra-ui/react';

import { useForm } from 'react-hook-form';

import * as yup from 'yup';
import { useYupValidationResolver } from '../../../../util/yupUtils';

import _ from 'lodash';

// wrapper
import MembershipFormWrapper from '../../MembershipFormWrapper';

// Form Sections and Field Array Form Sections
import {
  MachineriesSection,
  MachineriesFieldsValidation,
  RawMaterialRequirementSection,
  RawMaterialRequirementFieldsValidation,
  OtherRawMaterialInfoSection,
  OtherRawMaterialFieldsValidation,
  defaultOtherRawMaterialFieldValues,
  AnnualCapacitySection,
  AnnualCapacityFieldsValidation,
  TypeAndConstructionOfFabricSection,
  TypeAndConstructionOfFabricFieldsValidation,
  defaultTypeAndConstructionFieldValues,
} from './sections';

// Membership apis
import { patchMembership } from '../../../../api/membership';
// Constants
import { FABRIC_MANUFACTURER_FORM_SECTION } from '../../../../constants/membershipFormConstant';

// Yup validation Schema
const FabricManufacturerValidatonSchema = yup.object().shape({
  ...MachineriesFieldsValidation,
  ...AnnualCapacityFieldsValidation,
  ...OtherRawMaterialFieldsValidation,
  ...RawMaterialRequirementFieldsValidation,
  ...TypeAndConstructionOfFabricFieldsValidation,
});

const FabricManufacturerForm = ({ note, currentStep, setStep, defaultFields }) => {
  const resolver = useYupValidationResolver(FabricManufacturerValidatonSchema);
  const {
    handleSubmit,
    register,
    control,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver,
    defaultValues: {
      ...defaultFields,
      typeAndConstructionOfFabric: defaultFields.typeAndConstructionOfFabric?.length
        ? [...defaultFields.typeAndConstructionOfFabric]
        : [{ ...defaultTypeAndConstructionFieldValues }],
      otherRawMaterials: defaultFields.otherRawMaterials
        ? [...defaultFields.otherRawMaterials]
        : [{ ...defaultOtherRawMaterialFieldValues }],
    },
  });

  const onForwardSubmit = async (data) => {
    const cleanData = _.pickBy(data, _.identity);
    const cleanDefaultFields = _.pickBy(defaultFields, _.identity);
    if (_.isEqual(cleanData, cleanDefaultFields) === false) {
      await patchMembership(FABRIC_MANUFACTURER_FORM_SECTION, { ...data, note });
      setStep(currentStep + 1);
    } else {
      setStep(currentStep + 1);
    }
  };

  const onBackwardSubmit = async (data) => {
    const cleanData = _.pickBy(data, _.identity);
    const cleanDefaultFields = _.pickBy(defaultFields, _.identity);
    if (_.isEqual(cleanData, cleanDefaultFields) === false) {
      await patchMembership(FABRIC_MANUFACTURER_FORM_SECTION, { ...data, note });
      setStep(currentStep - 1);
    } else {
      setStep(currentStep - 1);
    }
  };

  return (
    <MembershipFormWrapper formName="Woven Fabric Manufacturer">
      <Grid templateColumns="repeat(2, 1fr)" gap={2}>
        <GridItem colSpan={2}>
          <MachineriesSection register={register} control={control} errors={errors} />
        </GridItem>
        <GridItem colSpan={2}>
          <AnnualCapacitySection register={register} control={control} errors={errors} />
        </GridItem>
        <GridItem colSpan={2}>
          <Divider />
        </GridItem>
        <GridItem colSpan={2}>
          <TypeAndConstructionOfFabricSection
            register={register}
            control={control}
            errors={errors}
          />
        </GridItem>
        <GridItem colSpan={2}>
          <Divider />
        </GridItem>
        <GridItem colSpan={2}>
          <RawMaterialRequirementSection register={register} control={control} errors={errors} />
          <OtherRawMaterialInfoSection register={register} control={control} errors={errors} />
        </GridItem>
        <GridItem colSpan={2}>
          <Divider />
        </GridItem>
        <GridItem colSpan={2}>
          <Text>
            <b>Note: </b>
            {note}
          </Text>
        </GridItem>
        <GridItem colSpan={2}>
          <Divider />
        </GridItem>
      </Grid>
      <Stack flexDir="column" alignItems="flex-end">
        <HStack mt={3}>
          <Button
            variant="formNext"
            onClick={(event) => {
              event.preventDefault();
              handleSubmit(onBackwardSubmit)();
            }}
            isLoading={isSubmitting}>
            PREVIOUS
          </Button>
          <Button
            variant="formNext"
            onClick={(event) => {
              event.preventDefault();
              handleSubmit(onForwardSubmit)();
            }}
            isLoading={isSubmitting}>
            NEXT
          </Button>
        </HStack>
      </Stack>
    </MembershipFormWrapper>
  );
};

export default FabricManufacturerForm;
